export function confirmationDialog(openDialog, confirmedButton, confirmedCallBack) {
  openDialog();

  confirmedButton.off('click');
  confirmedButton.on('click', function() {
    confirmedCallBack();
  })
}